var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41 292.9L46.23 369.87L144.37 313.49L99.64 236.12L1.41 292.9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287.87 252.34L311.54 238.53L248.12 128.53L115.2 205.53C133.75 237.51 176 310 176 310L191.53 301.68C191.77 301.55 192.08 301.68 192.36 301.68L102.65 496H137.81L236.86 281.75L260.1 268.35L358 464H394L287.87 252.34ZM262.08 96C286.89 138.23 322.33 200.25 348.48 244.76L510.79 151L424.07 1.41L262.08 96Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.a927f508559356df548087a2384c4d57.svg";
export { ForwardRef as ReactComponent };